module.exports = __webpack_public_path__ + "static/media/Eswatini - SZ.3b8fca41.png";